'use client';

import type {
  CategoriesEntity,
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';
import { HeaderCartButton } from '@eliadmin/core/src/components/header/header-cart-button';
import { HeaderProfileButton } from '@eliadmin/core/src/components/header/header-profile-button';
import { MobileSearchProvider } from '@eliadmin/core/src/components/header/mobile-search';
import MobileSidebar from '@eliadmin/core/src/components/header/mobile-sidebar';
import { HeaderSearchBar } from '@eliadmin/core/src/components/header/search-bar';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HeaderCategoriesButton } from './header-categories-button';
import { Logo } from '../ui/logo';
import { HeaderComparisionButton } from './header-comparision-button';
import { SearchButton } from '@eliadmin/core/src/components/header/search-button';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { HeaderFavoritesButton } from '@eliadmin/core/src/components/header/header-favorites-button';

export type HeaderMainProps = {
  generalLayout: GeneralLayout['data'];
  categories: CategoriesEntity[];
  locale: string;
  menu1?: Menu;
  menu2?: Menu;
};

export function HeaderMain({ generalLayout, categories, locale, menu1, menu2 }: HeaderMainProps) {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const isLogged = !!me && isInitialized;

  return (
    <MobileSearchProvider>
      <div className={cn('custom-section', 'bg-white py-2.5 lg:py-4', 'ea-header-main')}>
        <div
          className={cn('custom-container', 'hidden items-center justify-between gap-4 md:flex')}
        >
          <div className="flex w-full flex-1 items-center justify-start gap-2 xl:gap-3">
            <HeaderCategoriesButton categories={categories} locale={locale} />
            <div className="w-full min-w-[175px] max-w-[250px]">
              <HeaderSearchBar />
            </div>
          </div>
          <Logo priority generalLayout={generalLayout} className={{ image: 'h-12 lg:h-16' }} />
          <div className="flex w-full flex-1 items-center justify-end gap-3 xl:gap-4">
            <HeaderProfileButton />
            <div className="h-6 w-[1px] bg-border" />
            <HeaderComparisionButton />
            <div className="h-6 w-[1px] bg-border" />
            {isLogged && (
              <>
                <HeaderFavoritesButton />
                <div className="h-6 w-[1px] bg-border" />
              </>
            )}
            <HeaderCartButton />
          </div>
        </div>
        <div className="flex w-full items-center justify-between gap-4 md:hidden">
          <div className="flex w-full flex-1 items-center justify-start">
            <MobileSidebar menu1={menu1} menu2={menu2} generalLayout={generalLayout} />
          </div>
          <Logo priority className={{ image: 'h-12 sm:h-14' }} generalLayout={generalLayout} />
          <div className="flex w-full flex-1 items-center justify-end gap-3">
            <HeaderComparisionButton />
            <div className="h-6 w-[1px] bg-border" />
            <SearchButton />
          </div>
        </div>
      </div>
    </MobileSearchProvider>
  );
}
